// The Main Site Object
window.Site = {
    
    minutes : document.querySelector('.minutes'),
    hours   : document.querySelector('.hours'),

    openingHoursButtons : document.querySelectorAll('.opening-hours button'),

    // Init Function
    liftoff : () => {

        document.addEventListener('DOMContentLoaded' , Site.makeTheClockWork());
        Site.showHideOpenings()

    },

    makeTheClockWork : () => {

        let today = new Date();
        var h = (today.getHours() > 12) ? today.getHours() % 12 : today.getHours();
        var m = ("00" + today.getMinutes()).slice(-2);
        
        // Time to calculate the rotations
        let hoursRotation   = 360 / 12 * h;
        let minutesRotation = 360 / 60 * m;
        
        // We need to make things spin
        Site.hours.style.transform   = `rotate(${hoursRotation}deg)`;
        Site.minutes.style.transform = `rotate(${minutesRotation}deg)`;

        var t = setTimeout(Site.makeTheClockWork, 1000);
    },

    showHideOpenings : () => {

        Site.openingHoursButtons.forEach(button => {
            button.addEventListener('click' , () => {

                button.classList.toggle('active');

                if (Math.floor(button.nextElementSibling.clientHeight) == 0) {
                    button.nextElementSibling.style.height = `${button.nextElementSibling.firstElementChild.clientHeight + 1}px`;
                    setTimeout(function(){
                        button.scrollIntoView({ behavior: "smooth", block: "start" });
                    }, 350)
                } else {
                    button.nextElementSibling.style.height = "0px";
                }

            })
        })

    }

}

// Launch The Script
Site.liftoff()